const t = {
  name: "Topic",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 1H19V15H5V1ZM7 3V13H17V3H7Z" fill="currentColor"/>
<path d="M5 17H19V19H5V17Z" fill="currentColor"/>
<path d="M19 21H5V23H19V21Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Topic
};
